export type QualitySettings = {
  modelLOD: 'LOD0' | 'LOD1';
  resolution: Resolution;
  reflection: boolean;
  textureOption: Partial<TextureLoadOption>;
};
// * 해상도 순으로 정렬 필요
export enum Resolution {
  MAX = -1,
  p1440 = 1440,
  p1080 = 1080,
  p900 = 900,
  p720 = 720,
  NONE = 0,
}
export type TextureLoadOption = {
  textureMaxSize: '4096' | '2048' | '1024' | '512' | '256';
  useBaseColorTexture: boolean;
  useMetallicRoughnessTexture: boolean;
  useNormalTexture: boolean;
  useAmbientOcclusionTexture: boolean;
  useEmissiveTexture: boolean;
  useLightmapTexture: boolean;
  useReflectionProbe: boolean;
};
